import { render, staticRenderFns } from "./Parent.vue?vue&type=template&id=b4377262&scoped=true"
import script from "./Parent.vue?vue&type=script&lang=js"
export * from "./Parent.vue?vue&type=script&lang=js"
import style0 from "./Parent.vue?vue&type=style&index=0&id=b4377262&prod&scoped=true&lang=css"
import style1 from "./Parent.vue?vue&type=style&index=1&id=b4377262&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4377262",
  null
  
)

export default component.exports